import React from "react";
import { Box, Container, Grid } from "@mui/material";
import SEO from "../../hooks/SEO";
import PageBanner from "../../components/PageBanner";
import SectionHeader from "../../components/SectionHeader";
import BlogCard from "../../components/BlogCard";
import CTASection from "../../components/CTASection";
import { posts, seoContent, siteMeta } from "../../data/mockData";

const Blog = () => (
  <>
    <SEO
      title={seoContent.articles.title}
      description={seoContent.articles.description}
      name={siteMeta.name}
      type="website"
    />
    <PageBanner
      title="Articles"
      description="Commentary on mining, trade, petroleum services, industrial delivery, and project support."
      image={siteMeta.bannerImage}
      breadcrumbs={[{ label: "Articles" }]}
    />

    <Box className="site-section">
      <Container>
        <SectionHeader
          eyebrow="Editorial Preview"
          title="Sector Commentary"
          description="Articles covering mining, trade, petroleum services, industrial delivery, and related project support matters."
        />
        <Grid container spacing={3}>
          {posts.map((post) => (
            <Grid item xs={12} md={6} lg={4} key={post.id}>
              <BlogCard
                title={post.title}
                summary={post.summary}
                category={post.category}
                cover={post.cover}
                to={`/articles/${post.slug}`}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>

    <CTASection
      title="Discuss a Requirement"
      description="For formal inquiries, please use the contact page and the listed company details."
      primaryLabel="Contact Refwa"
      primaryTo="/contact"
      secondaryLabel="Explore Services"
      secondaryTo="/services"
    />
  </>
);

export default Blog;
